import { HOME_ACTIONS } from "./Home.actions";

export const HomeReducer = (state, action) => {
  switch (action.type) {
    case HOME_ACTIONS.LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case HOME_ACTIONS.ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case HOME_ACTIONS.CUSTOMERSLIST:
      return {
        ...state,
        customerList: action.payload,
        customers: action.payload,
        error: null,
      };
    case HOME_ACTIONS.SELECTEDCUSTOMER:
      return {
        ...state,
        selectedCustomer: action.payload,
      };
    case HOME_ACTIONS.SEARCHCUSTOMER: {
      const searchString = action.payload.toLowerCase();
      let filteredusers = state.customers
      if(searchString.length > 0) {
        filteredusers = state.customers.filter((customer) => {
        return (
          customer.groupName.toLowerCase().includes(searchString) ||
          customer.id.toString().includes(searchString)
        );
      });
      }
     
      return {
        ...state,
        customerList: filteredusers.length > 0 ? filteredusers : [],
      };
    }
    default:
      return { ...state };
  }
};